import { $translate } from '@/utils/i18n';
export const proObj = {
    title: $translate('lang.E3202103030009', { defaultText: '品质检验' }),
    list: [{
        span: 8,
        label: $translate('lang.E3202103030020', { defaultText: '产品编号' }),
        value: '',
        key: 'productCode'
    }, {
        span: 8,
        label: $translate('lang.E3202103030025', { defaultText: '产品型号' }),
        value: '',
        key: 'productType'
    }, {
        span: 8,
        label: $translate('lang.E3202103030030', { defaultText: '条码状态' }),
        value: '',
        key: 'barcodeStatus'
    }, {
        span: 8,
        label: $translate('lang.E3202103030026', { defaultText: '生产工单' }),
        value: '',
        key: 'moName'
    }, {
        span: 8,
        label: $translate('lang.E3202103030031', { defaultText: '工单数量' }),
        value: '',
        key: 'moQty'
    }, {
        span: 8,
        label: $translate('lang.E3202103030032', { defaultText: '下线完工数' }),
        value: '',
        key: 'moFinishQty'
    }, {
        span: 8,
        label: $translate('lang.E3202103030023', { defaultText: '车间' }),
        value: '',
        key: 'workshopDesc'
    }, {
        span: 8,
        label: $translate('lang.E3202103030024', { defaultText: '产线' }),
        value: '',
        key: 'lineDesc'
    }, {
        span: 8,
        label: $translate('lang.E3202103030033', { defaultText: '销往地' }),
        value: '',
        key: 'saleTo'
    }, {
        span: 8,
        label: $translate('lang.E3202103030034', { defaultText: '检验结果' }),
        value: '',
        key: 'inspectResut'
    }, {
        span: 8,
        label: $translate('lang.E3202103030035', { defaultText: '客户订单' }),
        value: '',
        key: 'customerOrder'
    }, {
        span: 8,
        label: $translate('lang.E3202103030029', { defaultText: '大箱条码' }),
        value: '',
        key: 'cartonBarcode'
    }]
};